/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lp_Welcome_Landing_Subscribetitle2Inputs */

const en_coinvestments_lp_welcome_landing_subscribetitle2 = /** @type {(inputs: Coinvestments_Lp_Welcome_Landing_Subscribetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe digitally`)
};

/**
* | output |
* | --- |
* | "Subscribe digitally" |
*
* @param {Coinvestments_Lp_Welcome_Landing_Subscribetitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_welcome_landing_subscribetitle2 = /** @type {((inputs?: Coinvestments_Lp_Welcome_Landing_Subscribetitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Welcome_Landing_Subscribetitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_welcome_landing_subscribetitle2(inputs)
});
export { coinvestments_lp_welcome_landing_subscribetitle2 as "coInvestments_lp_welcome_landing_subscribeTitle" }